import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { Engine, Manufacturer } from 'src/typings';
import { EngineCreateComponent } from '../engine-create/engine-create.component';
import { EngineService } from '../engine.service';

@Component({
  selector: 'app-engine-select',
  templateUrl: './engine-select.component.html',
  styleUrls: ['./engine-select.component.scss']
})
export class EngineSelectComponent {
  selectable = true;

  removable = true;

  separatorKeysCodes: number[] = [ENTER, COMMA];

  engineCtrl = new UntypedFormControl();

  filteredEngines: Engine[] = [];

  allEngines: Engine[] = [];

  @Input() control: UntypedFormControl = new UntypedFormControl();

  @Input() manufacturer: Manufacturer | undefined;

  get selectedEngines(): Engine[] {
    return this.control.value;
  }

  constructor(private engineService: EngineService, private dialog: MatDialog) {
    this.control.setValue([]);
    this.updateList();
    this.engineService.newEngineGW.subscribe(() => {
      this.updateList();
    });
    this.engineCtrl.valueChanges.subscribe((value) => {
      this.filter(value);
    });
  }

  updateList() {
    this.engineService.search().subscribe((list) => {
      this.allEngines = list.data;
      this.filteredEngines = list.data;
    });
  }

  filter(value: any) {
    if (typeof value !== 'string') {
      this.filteredEngines = this.allEngines;
    } else {
      this.filteredEngines = this.allEngines.filter((engine) => {
        return engine.description.toLowerCase().includes(value.toLowerCase());
      });
    }
  }

  remove(id: number): void {
    const tempEngine = [...this.selectedEngines];
    const index = tempEngine.findIndex((engine) => engine.id === id);

    if (index >= 0) {
      tempEngine.splice(index, 1);
      this.control.setValue(tempEngine);
    }
  }

  select(event: MatAutocompleteSelectedEvent): void {
    if (typeof event.option.value === 'string') {
      this.createEngine();
    } else {
      const testInclude = this.selectedEngines.find(
        (engine) => engine.id === event.option.value.id
      );
      if (testInclude) return;
      this.control.setValue([...this.selectedEngines, event.option.value]);
      this.engineCtrl.setValue(null);
    }
  }

  createEngine() {
    const dialogRef = this.dialog.open(EngineCreateComponent);
    dialogRef.componentInstance.dialogRef = dialogRef;
    if (typeof this.engineCtrl.value === 'string')
      dialogRef.componentInstance.description = this.engineCtrl.value || '';
    if (this.manufacturer) dialogRef.componentInstance.manufacturer = this.manufacturer;
  }
}
